export default {
  viewBox: '0 0 24 24',
  width: '24',
  height: '24',
  fill: 'none',
  rects: [
    {
      x: '4',
      y: '3',
      width: '6',
      height: '17',
      stroke: '#4A4A4A',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    {
      x: '14',
      y: '3',
      width: '6',
      height: '17',
      stroke: '#4A4A4A',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
}
